<template>
	<v-container
		class="content"
		fluid
		:style="processTicketDialog ? 'overflow-y:hidden; padding:0px;' : ''"
	>
		<v-flex xs-12 v-show="processTicketDialog">
			<iframe
				:src="processTicketSourceUrl"
				width="100%"
				:height="currentWindowHeight"
				style="border: 0px; width: 100%"
			></iframe>
		</v-flex>

		<v-layout v-show="!processTicketDialog" column>
			<v-flex>
				<h1 class="display-1 px-0">Beanstandungen von Kunden</h1>
			</v-flex>
			<v-flex>
				<v-switch
					color="accent"
					v-model="showResolved"
					label="Bearbeitete anzeigen"
					title="Bereits bearbeitete Beanstandungen auch anzeigen."
				>
				</v-switch>
			</v-flex>
			<v-flex>
				<v-data-table
					:headers="ticketHeaders"
					:items="allTickets"
					:loading="dataLoading"
					hide-actions
					class="elevation-1"
				>
					<v-progress-linear
						slot="progress"
						color="accent"
						indeterminate
					></v-progress-linear>
					<template slot="items" slot-scope="props">
						<tr>
							<td class="text-xs-left">{{ props.item.orderId }}</td>
							<td class="text-xs-left">
								{{ props.item.createdAt | formatDateAndTime }}
							</td>
							<td class="text-xs-left">
								<!-- Fertig -->
								<span
									v-if="props.item.ticketState > 1 || props.item.ticketState == 0"
								>
									<v-icon color="green" title="Abgeschlossen"
										>check_circle</v-icon
									>
									Abgeschlossen
								</span>
								<!-- Waiting for Blexon Action -->
								<span v-else>
									<span v-if="!props.item.manufacturerHasDecided">
										<v-icon color="red" title="Offen">error</v-icon>
										Bitte bearbeiten
									</span>
									<span v-else>
										<v-icon color="accent" title="Offen">info</v-icon>
										Warten auf Blexon
									</span>
								</span>
							</td>
							<td class="text-xs-left">
								<span>{{ getResolution(props.item) }}</span>
							</td>
							<td class="text-xs-left">
								<v-btn class="blexon-button" @click="openTicket(props.item.id)"
									>Anzeigen</v-btn
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import httpClient from "../store/httpClient";
import resolutionTypes from "../dtos/resolutionTypes";

export default {
	data() {
		return {
			dataLoading: false,
			allTickets: [],
			processTicketSourceUrl: "",
			processTicketDialog: false,
			currentWindowHeight: "100px",
			ticketHeaders: [
				{
					text: "Auftrag Id",
					align: "left",
					sortable: false,
					width: "15%",
				},
				{
					text: "Erfasst am",
					align: "left",
					sortable: false,
					width: "15%",
				},
				{
					text: "Status",
					align: "left",
					sortable: false,
					width: "30%",
				},
				{
					text: "Lösung Blexon",
					align: "left",
					sortable: false,
					width: "15%",
				},
				{
					text: "Link zum Bearbeiten",
					align: "left",
					sortable: false,
					width: "25%",
				},
			],
		};
	},
	mounted() {
		this.loadOpenTickets();
	},
	watch: {
		showResolved() {
			this.loadOpenTickets();
		},
	},
	computed: {
		showResolved: {
			get() {
				// you can right any getter/state here
				return this.$store.state.showResolved;
			},
			set(val) {
				// you can right any getter/state here
				this.$store.commit("setShowResolved", val);
			},
		},
	},

	methods: {
		/**
		 * Loads all open tickets of the loggedin fertiger
		 */
		async loadOpenTickets() {
			try {
				this.dataLoading = true;
				const fertigerId = this.$route.params.fertigerId;
				const response = await httpClient().get(
					`api/Ticket/GetTicketsOfFertiger?fertigerId=${fertigerId}&onlyOpen=${!this.showResolved}`
				);
				this.allTickets = response.data;
			} catch (err) {
				console.log(err);
			} finally {
				this.dataLoading = false;
			}
		},
		openTicket(id) {
			this.$router.push({
				name: "ticketDetail",
				params: {
					fertigerId: this.$route.params.fertigerId,
					id: id,
				},
			});
		},
		getResolution(ticketState) {
			return ticketState.resolutions.map((r) => resolutionTypes[r].text).join(", ");
		},
	},
};
</script>
